module.exports = __webpack_public_path__ + "static/media/signage-industrial-img27.aeccbdf1.jpg";